/* tslint:disable */
/* eslint-disable */
/**
 * Project Freelancer API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface InitiateProjectRenewalRequest
 */
export interface InitiateProjectRenewalRequest {
    /**
     * 
     * @type {string}
     * @memberof InitiateProjectRenewalRequest
     */
    adminComment?: string;
}

/**
 * Check if a given object implements the InitiateProjectRenewalRequest interface.
 */
export function instanceOfInitiateProjectRenewalRequest(value: object): value is InitiateProjectRenewalRequest {
    return true;
}

export function InitiateProjectRenewalRequestFromJSON(json: any): InitiateProjectRenewalRequest {
    return InitiateProjectRenewalRequestFromJSONTyped(json, false);
}

export function InitiateProjectRenewalRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): InitiateProjectRenewalRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'adminComment': json['adminComment'] == null ? undefined : json['adminComment'],
    };
}

export function InitiateProjectRenewalRequestToJSON(value?: InitiateProjectRenewalRequest | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'adminComment': value['adminComment'],
    };
}

